export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-gerenciamento-medico' */ '@/views/ambulatorio/gerenciamento-medico/Index'),
        path: 'gerenciamento-medico',
        redirect: 'gerenciamento-medico/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-gerenciamento-medico' */'@/views/ambulatorio/gerenciamento-medico/List.vue'),
                name: 'ambulatorio-gerenciamento-medico-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-gerenciamento-medico' */ '@/views/ambulatorio/gerenciamento-medico/Form.vue'),
                name: 'ambulatorio-gerenciamento-medico-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
            },
        ],
    },
]